import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DashboardStats } from 'src/app/dashboard/models/dashboard-stats.model';
import { LiveWorker } from 'src/app/dashboard/models/live-worker.model';
import { WorkerHistory } from 'src/app/dashboard/models/worker-history.model';
import { environment } from 'src/app/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DashboardService {

    // ✅ Use environment.apiUrl
    private api = `${environment.apiUrl}/api/dashboard`;

  constructor(private http: HttpClient) {}

  getStats(): Observable<DashboardStats> {
    return this.http.get<DashboardStats>(`${this.api}/stats`);
  }

  getLiveWorkers(): Observable<LiveWorker[]> {
    return this.http.get<LiveWorker[]>(`${this.api}/live-workers`);
  }

  getWorkerHistory(userId: string): Observable<WorkerHistory[]> {
    return this.http.get<WorkerHistory[]>(`${this.api}/history/${userId}`);
  }

  getActivity() {
  return this.http.get<any[]>(`${this.api}/activity`);
}

}